module.exports = __webpack_public_path__ + "img/ee.8e8dc121.svg";